import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 6px;

  button.p-button.p-button-icon-only {
    height: auto;
    padding: 0;
    border: 0;

    &:hover {
      background: transparent !important;
    }
  }
`;

const ActionIcon = styled.i`
  background-color: transparent;
  color: #64748b;
  cursor: pointer;

  &:hover {
    color: #64748b;
  }
`;

const ApproverLink = styled(Link)`
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  aling-items: center;
  gap: 5px;
  cursor: pointer;
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.negative};

  i {
    color: ${({ theme }) => theme.colors.negative};
    border: 2px;
  }

  span {
    text-decoration: underline;
  }

  &:hover {
    span {
      text-decoration: none;
      color: ${({ theme }) => theme.colors.negative};
    }
    i {
      color: ${({ theme }) => theme.colors.negative};
    }
  }
`;

export { ActionsWrapper, ActionIcon, ApproverLink };
